import request from '@/utils/request'

// 获取同步用户列表
export const getSyncUserLists = (data) => {
    return request({
        url: '/zju/user/lists',
        params: data
    })
}

// 同步用户-详情
export const getSyncUserDetail = (id) => {
    return request({
        url: `/zju/user/${id}`
    })
}

// 批量导入同步用户
export const batchiImport = (data) => {
    return request({
        url: '/zju/user/manage',
        method: 'PATCH',
        data: {
            method: 'batch_import',
            data
        }
    })
}
